export function periodBounds(year, month) {
  if (!Number.isInteger(year) || year < 1900 || year > 2200
    || (month !== undefined && (!Number.isInteger(month) || month < 1 || month > 12))) {
    throw new Error('Choose a valid reporting period.');
  }
  const from = `${year}-${String(month || 1).padStart(2, '0')}-01`;
  const nextMonth = month === undefined || month === 12 ? 1 : month + 1;
  const nextYear = month === undefined || month === 12 ? year + 1 : year;
  return {from, to: `${nextYear}-${String(nextMonth).padStart(2, '0')}-01`};
}

// A fresh query for every page preserves the scope and ordering. Continue even
// when the server caps a response below the requested page size.
export async function fetchAllRows(makeQuery, idColumn = 'id') {
  const rows = [];
  const seen = new Set();
  for (;;) {
    const {data, error} = await makeQuery().order(idColumn).range(rows.length, rows.length + 499);
    if (error) throw error;
    if (!data?.length) return rows;
    for (const row of data) {
      if (seen.has(row[idColumn])) throw new Error('Records changed during export. Please try again.');
      seen.add(row[idColumn]);
    }
    rows.push(...data);
  }
}

export function sumMoney(rows, field) {
  let cents = 0;
  for (const row of rows) {
    const text = String(row[field] ?? 0);
    if (!/^-?\d+(?:\.\d{1,2})?$/.test(text)) throw new Error('Invalid monetary value in records.');
    cents += Math.round(Number(text) * 100);
    if (!Number.isSafeInteger(cents)) throw new Error('Export amount exceeds supported precision.');
  }
  return cents / 100;
}

export function csvValue(value) {
  let text = value == null ? '' : String(value);
  // Quoting alone does not prevent spreadsheet formula execution.
  if (typeof value === 'string' && /^\s*[=+\-@]/.test(text)) text = "'" + text;
  return `"${text.replaceAll('"', '""')}"`;
}
export function rowsToCsv(rows) {
  return '\uFEFF' + rows.map(row => row.map(csvValue).join(',')).join('\r\n');
}
